import { Component, OnInit, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { take } from 'rxjs';

import { ButtonModule } from 'primeng/button';
import { FileUploadEvent, FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';

import { CompanyCRUDService, CompanyReadOnlySchema, JSendModelResponse, Watermark } from '@digitalforest/ngx-oak-api';

import { ZXingScannerComponent } from '@zxing/ngx-scanner';

@Component({
  selector: 'app-watermark-page',
  templateUrl: './watermark-page.component.html',
  styleUrls: ['./watermark-page.component.scss'],
  standalone: true,
  imports: [FileUploadModule, ProgressBarModule, ButtonModule],
})
export class WatermarkPageComponent implements OnInit {
  @ViewChild('scanner') scanner!: ZXingScannerComponent;
  operationInProgress = false;
  email: string | undefined;
  timestamp: string | undefined;
  message: string | undefined;
  private company?: CompanyReadOnlySchema;

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private companyCRUDService = inject(CompanyCRUDService);

  private readonly companyId = parseInt(this.route.snapshot.paramMap.get('company_id') || '0');

  ngOnInit(): void {
    // FIXME: add error handling
    this.companyCRUDService
      .manageGetCompany(this.companyId)
      .pipe(take(1))
      .subscribe((value) => {
        this.company = value;
      });
  }

  onUpload($event: FileUploadEvent) {
    // In PrimeNG, the response is usually in the body property of the originalEvent
    const eventWithBody = $event as { originalEvent: { body: unknown } };
    const response: JSendModelResponse = eventWithBody.originalEvent.body as JSendModelResponse;

    switch (response.status) {
      case 'success': {
        const watermark: Watermark = response.data as Watermark;
        this.message = 'Watermark found';
        this.email = watermark.email;
        this.timestamp = watermark.timestamp;
        break;
      }

      case 'error':
        this.message = 'Watermark not found';
        this.email = undefined;
        this.timestamp = undefined;
        break;
    }
  }

  getUploadUrl() {
    // FIXME: make configurable
    return `https://api.oak-events.com/api/manage/crud/company/${this.companyId}/media_gallery/verify`;
  }

  resetVerification() {
    this.message = undefined;
    this.email = undefined;
    this.timestamp = undefined;
  }
}
